import {
  ICountryStatisticsBackEndModel,
  IEducationTypeStatisticsBackEndModel,
} from "../types";
import {
  EDUCATION_TYPES_MAP,
  EducationType,
} from "../../school/constants/types";
import { PI_CHART_COLORS } from "../constants";
import { getName } from "country-list";
import { IPieChartSegment } from "../../../components/PieChart/types";

export const getFilterOptions = (data) => {
  let filterOptions = {} as any;

  if (data?.educationType) {
    filterOptions.educationType = data.educationType.id;
  }

  if (data?.startDate) {
    filterOptions.startDate = data.startDate.toISOString();
  }

  if (data?.endDate) {
    filterOptions.endDate = data.endDate.toISOString();
  }

  return filterOptions;
};

export const parseToEducationTypesStatisticsModel = (
  response: IEducationTypeStatisticsBackEndModel,
): IPieChartSegment[] => [
  {
    name: EDUCATION_TYPES_MAP[EducationType.Higher],
    value: response[EducationType.Higher],
    color: PI_CHART_COLORS[0],
  },
  {
    name: EDUCATION_TYPES_MAP[EducationType.Secondary],
    value: response[EducationType.Secondary],
    color: PI_CHART_COLORS[1],
  },
];

export const parseToCountryStatisticsModel = (
  response: ICountryStatisticsBackEndModel[],
): IPieChartSegment[] =>
  response.map((item, index) => ({
    name: item.country ? getName(item.country)! : "Other Countries",
    value: item.count,
    color: item.country
      ? PI_CHART_COLORS[index]
      : PI_CHART_COLORS[PI_CHART_COLORS.length - 1],
  }));
